module.exports = __webpack_public_path__ + "static/media/sample13.6545b933.jpg";